import React, { Component } from 'react'
import { subscriptions } from '@services/api'
import { Collapse, Icon, Popconfirm, Button } from 'antd'
import ManageServicesForSubs from '@components/Popup/ManageServicesForSubs'
import Subscription from './Subscription'
import AddNewSubscription from './AddNewSubscription'
import { inject, observer } from 'mobx-react'

@inject((store: any) => {
    const { authStore } = store
    return { authStore }
})
@observer
export default class extends Component {
    state = { subs: [] }
    componentDidMount() {
        this.refreshSubs()
    }

    refreshSubs = () => subscriptions.getSubscriptions().then(res => this.setState({ subs: res.data }))

    render() {
        const { subs } = this.state
        const { Panel } = Collapse
        const getFreezeIcon = (id, active) => (
            <Popconfirm
                title={`האם אתה בטוח שברצונך ${active ? 'להקפיא' : 'לבטל הקפאת'} מסלול זה?`}
                okText="אני בטוח/ה"
                cancelText="ביטול"
                onConfirm={async event => {
                    event.stopPropagation()
                    event.preventDefault()
                    await subscriptions.handleFreezeSub(id, +!active)
                    this.refreshSubs()
                }}
            >
                <Button
                    onClick={event => {
                        event.stopPropagation()
                        event.preventDefault()
                    }}
                >
                    <Icon type={active ? 'lock' : 'unlock'} />
                </Button>
            </Popconfirm>
        )
        return subs.length ? (
            <Collapse style={{ flexDirection: 'column' }} accordion>
                {subs.map((item, idx) => (
                    <Panel
                        header={`מזהה: ${item.id}, ${item.name}${item.type == 'AGENT' ? '- סוכן' : ''}`}
                        key={idx}
                        extra={getFreezeIcon(item.id, !!item.active)}
                        style={{ textDecoration: !!item.active ? undefined : 'line-through' }}
                        disabled={!item.active}
                    >
                        <Subscription item={item} refreshSubs={this.refreshSubs} />
                    </Panel>
                ))}
                <Panel
                    header={`הוסף מסלול חדש`}
                    key={subs.length + 1}
                    disabled={!this.props.authStore.roles.includes('admin')}
                >
                    <AddNewSubscription refreshSubs={this.refreshSubs} />
                </Panel>
                <ManageServicesForSubs refreshSubs={this.refreshSubs} />
            </Collapse>
        ) : (
            <Icon type="loading" />
        )
    }
}
